import i18next from "i18next";
import moment from "moment";

export const noValidation = () => {
  return {
    msg: null,
    func: () => true
  };
};

export const isEmail = () => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return {
    msg: i18next.t("Validations.Generic.Email"),
    func: value => !value || re.test(String(value).toLowerCase())
  };
};

export const isPhone = () => {
  var re = /^(07[2-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|)?([0-9]{3}(\s|\.|)){2}$/;
  return {
    msg: i18next.t("Validations.Generic.Phone"),
    func: value => !value || re.test(String(value))
  };
};

export const noSpaceAtBeginning = () => {
  var input = /^[^-\s]([a-zA-Z0-9])/;
  return {
    msg: i18next.t("Validations.Generic.NoSpace"),
    func: value => input.test(String(value))
  };
};

export const checkForDuplicateUniqueId = clientUniqueId => {
  return {
    msg: i18next.t("Validations.AssociatedPartner.DuplicateUniqueId"),
    func: value => !(value === clientUniqueId)
  };
};

export const validateSeriesAndNumber = (value, countryCode) => {
  if (countryCode === "RO") return isRomanianSeriesAndNumber(value);
  if (countryCode === "BG") return isBulgarianSeriesAndNumber(value);
};

export const isRomanianSeriesAndNumber = function isRomanianSeriesAndNumber(x) {
  const input = /^[A-Za-z]{2}\d{6,7}$/;
  return input.test(String(x));
};

export const isBulgarianSeriesAndNumber = function isBulgarianSeriesAndNumber(x) {
  const input = /^\d{9}$/;
  return input.test(String(x));
};

export const isCnp = () => {
  return {
    msg: i18next.t("Validations.Generic.CNP"),
    func: p_cnp => {
      if (!p_cnp) return true;
      if (p_cnp.length !== 13) {
        return false;
      }

      // Validate all are numbers
      if (isNaN(Number(p_cnp)) || parseInt(p_cnp, 10) !== Number(p_cnp)) {
        return false;
      }

      // Setup:
      let i = 0,
        year = 0,
        month = 0,
        day = 0,
        hashResult = 0,
        cnp = [],
        hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
      const extraDateValues = "00:00:00 +0000";

      // Calculate condition number
      for (i = 0; i < 13; i++) {
        cnp[i] = parseInt(p_cnp[i], 10);
        if (i < 12) {
          hashResult = hashResult + cnp[i] * hashTable[i];
        }
      }

      hashResult = hashResult % 11;
      if (hashResult === 10) {
        hashResult = 1;
      }

      // Validate birthday
      year = cnp[1] * 10 + cnp[2];
      month = cnp[3] * 10 + cnp[4];
      day = cnp[5] * 10 + cnp[6];

      switch (cnp[0]) {
        case 1:
        case 2:
          year += 1900;
          break;
        case 3:
        case 4:
          year += 1800;
          break;
        case 5:
        case 6:
          year += 2000;
          break;
        case 7:
        case 8:
        case 9:
          year += 2000;
          if (year > new Date().getFullYear() - 18) {
            year -= 100;
          }
          break;
        default: {
          return false;
        }
      }

      if (year < 1800 || year > 2099) {
        return false;
      }
      const birthday = Date.parse(`${year} ${month} ${day} ${extraDateValues}`);
      if (isNaN(birthday)) {
        return false;
      }

      // Validate condition number
      return cnp[12] === hashResult;
    }
  };
};

export const checkBirthDateAccordingToUniqueId = (cnp, birthDate, countryCode) => {
  if (!cnp) return true;
  if (!birthDate) return false;

  let cnpDate;
  switch (countryCode) {
    case "RO":
      cnpDate = extractBirthDateFromCnp(cnp);
      break;
    case "BG":
      cnpDate = extractBirthDateFromEGN(cnp);
      break;
    default:
      return false;
  }

  if (!cnpDate) return false;
  cnpDate.setHours(0, 0, 0, 0);

  const actualBirthDate = new Date(Date.parse(birthDate));
  actualBirthDate.setHours(0, 0, 0, 0);
  if (cnpDate.valueOf() !== actualBirthDate.valueOf()) return false;
  return true;
};

export const extractBirthDateFromEGN = egn => {
  if (!egn) return null;

  const yearSuffix = egn.substring(0, 2);
  const month = egn.substring(2, 4);
  const day = egn.substring(4, 6);
  var yearOfBirth = null;

  const currentYear = new Date().getFullYear() % 100;
  if (parseInt(yearSuffix) > currentYear) {
    yearOfBirth = "19" + yearSuffix;
  } else {
    yearOfBirth = "20" + yearSuffix;
  }
  if (yearOfBirth) return new Date(yearOfBirth, month - 1, day);
  return null;
};

export const extractBirthDateFromCnp = cnp => {
  if (!cnp) return null;
  if (!isCnp(cnp)) return null;

  const sexChar = cnp.substring(0, 1);
  const yearSuffix = cnp.substring(1, 3);
  const month = cnp.substring(3, 5);
  const day = cnp.substring(5, 7);
  let yearOfBirth = null;

  if (sexChar === '1' || sexChar === '2') yearOfBirth = '19' + yearSuffix;
  if (sexChar === '5' || sexChar === '6') yearOfBirth = '20' + yearSuffix;
  if (sexChar === '3' || sexChar === '4') yearOfBirth = '18' + yearSuffix;
  if (sexChar === '7' || sexChar === '8') {
    let currentYearSuffix = new Date().getFullYear() % 100;
    let yearPrefix = yearSuffix <= currentYearSuffix ? '20' : '19';
    yearOfBirth = yearPrefix + yearSuffix;
  }
  if (yearOfBirth) return new Date(yearOfBirth, month - 1, day);
  return null;
};
export const isMandatory = () => {
  return {
    msg: i18next.t("Validations.Generic.Mandatory"),
    func: value => value !== null && value !== undefined && value !== ""
  };
};

export const isInRange = (min, max) => {
  // const minString = typeof min === "function" ? "" : min;
  // const maxString = typeof max === "function" ? "" : max;
  // const string = " (" + minString + " - " + maxString + ")";
  // TODO: make it right

  return {
    msg: i18next.t("Validations.Generic.OutOfRange"),
    func: (value, document) => {
      const left = typeof min === "function" ? min(document) : min;
      const right = typeof max === "function" ? max(document) : max;
      return (!value && value !== 0) || (value >= left && value <= right);
    }
  };
};

export const isDerivedInRange = (map, min, max) => {
  return {
    msg: i18next.t("Validations.Generic.OutOfRange"),
    func: (value, document) => {
      const left = typeof min === "function" ? min(document) : min;
      const right = typeof max === "function" ? max(document) : max;
      const derivedValue = map(value);
      return (!derivedValue && derivedValue !== 0) || (derivedValue >= left && derivedValue <= right);
    }
  };
};

export const isGreaterThan = min => {
  return {
    msg: i18next.t("Validations.Generic.OutOfRange"),
    func: (value, document) => {
      const left = typeof min === "function" ? min(document) : min;
      return value > left;
    }
  };
};

export const dateIsGreaterThan = min => {
  return {
    msg: i18next.t("Validations.Generic.OutOfRange"),
    func: (value, document) => {
      const left = typeof min === "function" ? min(document) : min;
      return left ? moment(value).isSameOrAfter(moment(left)) : true;
    }
  };
};

export const dateIsLessThan = max => {
  return {
    msg: i18next.t("Validations.Generic.OutOfRange"),
    func: (value, document) => {
      const right = typeof max === "function" ? max(document) : max;
      return right ? moment(value).isSameOrBefore(moment(right)) : true;
    }
  };
};

export const foreach = itemValidationRule => (_, items) =>
  items.reduce(
    (accumulator, item, index) => ({
      ...accumulator,
      [index]: typeof itemValidationRule === "function" ? itemValidationRule(item) : itemValidationRule
    }),
    {}
  );
export const foreachProp = itemValidationRule => (document, values) =>
  Object.keys(values).reduce(
    (accumulator, prop) => ({
      ...accumulator,
      [prop]: typeof itemValidationRule === "function" ? itemValidationRule(document, values[prop]) : itemValidationRule
    }),
    {}
  );
